const state = {
  loginInformation: {},
  purchaseType: undefined,
};

export default state;
